import { ToggleSwitch } from "../buttonsLibrary";
import { Popper } from "../../Popper";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { ClickAwayListener } from "../ClickAwayListener";
import {
  onOptionButtonDownRedirectHome,
  onOptionButtonDownRedirectPrint,
} from "../../functions/Functions_General";
import { Page } from "./Page";
// import { GameData } from "../../../firecubes/gamestate/gameData";
import { onOptionButtonDown } from "../../functions/Functions_OptionWindow";
import {
  toggleFullScreenOption,
  toggleFullHD,
  toggle60Fps,
  toggleMuteOption,
  toggleBonusMusicOption,
  changeSoundVolume,
  toggleTurboMode,
} from "../../functions/Function_settingsPage";
import { getParameterByName } from "../../getParameters";
import { starLog } from "../../functions/helper.ts/logger";
import { isFullScreen } from "../../functions/helper.ts/FullScreenHelper";

let mainColor: number = 0xba8623;
let subColor: number = 0xffffff;

export class OptionBuilder extends Popper {
  private isClosed: boolean;
  private parentContainer: PIXI.Container;
  private bgContainer: PIXI.Container;
  private bgContainerPortrait: PIXI.Container;
  private portraitBG: PIXI.Sprite;
  private messageContainer: PIXI.Container;
  private pagesContainer: Array<PIXI.Container>;

  private pagesContainerRoot: PIXI.Container;
  private pages: Array<Page>;
  private totalPages: number;
  private currentPage: number;
  private iconHighlight: Array<PIXI.Graphics>;
  private sidebar: PIXI.Sprite;
  private optionBlackBG: PIXI.Sprite;
  private home: PIXI.Sprite;
  private closeBtn: PIXI.Sprite;
  private print: PIXI.Sprite;
  private next: PIXI.Sprite;
  private previous: PIXI.Sprite;
  private goal: PIXI.Sprite;
  private jackpot: PIXI.Sprite;
  private setting: PIXI.Sprite;
  private fullscreentoggleSwitch: ToggleSwitch;
  private bgMusicToggleSwitch: ToggleSwitch;
  private animationtoggleSwitch: ToggleSwitch;
  private soundsliderButton: ToggleSwitch;
  private bonusMusicToggleSwitch: ToggleSwitch;
  private fullHDSliderButton: ToggleSwitch;
  private fullFpsSlierButton: ToggleSwitch;

  private TurboSlierButton: ToggleSwitch;
  private activeGameData: CommonData;

  private settingBtnsContainer: PIXI.Container;
  private replayBtn: PIXI.Sprite;

  private bgWidth: number;
  private bgHeight: number;
  private offsetY: number;
  private displayModeLandscape: boolean;
  private desktopSmallScreen: boolean;

  constructor(
    parent: PIXI.Container,
    activeGameData: CommonData,
    totalPages: number
  ) {
    super(activeGameData);
    this.displayModeLandscape = true;

    this.isClosed = true;

    this.parentContainer = new PIXI.Container();
    parent.addChild(this.parentContainer);
    this.messageContainer = new PIXI.Container();

    this.pagesContainerRoot = new PIXI.Container();
    this.messageContainer.addChild(this.pagesContainerRoot);
    this.pages = [];
    this.totalPages = totalPages + 2; //two pages are for option and jackpot created by default
    this.currentPage = 0;
    this.iconHighlight = [];
    this.sidebar = new PIXI.Sprite(PIXI.Texture.fromImage("gambleLines.png"));
    this.activeGameData = activeGameData;

    this.desktopSmallScreen = activeGameData.displayOptionSmall;
    if (this.activeGameData.isMobile) {
      this.desktopSmallScreen = true; //default false on mobile
    }

    this.createBG();
    this.createNavButtoms();

    this.rescaleOptionToFitCenter(); //option gets smaller on desktop version ;

    activeGameData.gameBar.setOptionBtnFunction(
      onOptionButtonDown.bind(this, activeGameData)
    );
    this.autoSetupFunctions(); //setup default functions to the buttons

    this.bgWidth = 0;
    this.bgHeight = 0;
    this.offsetY = 0;

    this.setDisplayMode();
    this.setActivePage("goal");
  }
  public setPageTitelColor = (newColor: number): void => {
    for (let i = 0; i < this.pages.length; i++) {
      this.pages[i].setTitelColor(newColor);
    }
  };
  private createBG = (): void => {
    this.bgContainer = new PIXI.Container();
    this.parentContainer.addChild(this.bgContainer);
    this.optionBlackBG = new PIXI.Sprite(
      PIXI.Texture.fromImage("gambleBG.png")
    );
    this.bgContainer.addChild(this.optionBlackBG);
    this.optionBlackBG.interactive = false;
    this.optionBlackBG.on(
      "pointertap",
      function() {
        // e.preventDefault();
        return false;
      }.bind(this)
    );
    // this.pagesContainerRoot.addChild(this.sidebar);
    this.sidebar.position.set(this.bgContainer.width / 2, 105);
    this.sidebar.anchor.set(0.5);
    this.sidebar.scale.set(0.9, 0.5);
    this.sidebar.height = 2;
    this.addClickAwayListener(
      new ClickAwayListener(
        this.activeGameData.stage,
        this.bgContainer,
        this.close.bind(this)
      )
    );

    this.bgContainerPortrait = new PIXI.Container();
    this.parentContainer.addChild(this.bgContainerPortrait);

    this.portraitBG = new PIXI.Sprite(PIXI.Texture.fromImage("gambleBG.png"));
    this.portraitBG.rotation = Math.PI / 2;

    this.portraitBG.anchor.set(0, 1); //.5);
    this.portraitBG.position.set(0);
    this.portraitBG.scale.set(0);
    // this.portraitBG.width =this.activeGameData.size[0];
    if (this.activeGameData.isMobile) {
      this.bgContainerPortrait.addChild(this.portraitBG);
    }

    // this.portraitBG.alpha=0
    this.bgContainer.width = this.activeGameData.size[0]; //activeGameData.gameResolution=gameScene.width;
    this.bgContainer.height =
      this.activeGameData.size[1] -
      this.activeGameData.gameBar.getGameBarHeight();

    if (this.activeGameData.isMobile || this.desktopSmallScreen == false) {
      this.bgContainer.height = this.activeGameData.size[1] - 140;
    } else {
      this.bgContainer.width = 1175;
      this.bgContainer.x =
        this.activeGameData.size[0] / 2 - this.bgContainer.width / 2; //
      this.bgContainer.height = 730;
      this.bgContainer.y =
        this.activeGameData.size[1] / 2 - this.bgContainer.height / 2 + 12.5; //;
    }

    // this.bgContainer.alpha=.5;
  };

  private setDisplayMode = (): void => {
    let screenRatio = window.innerHeight / window.innerWidth;
    // let orientationPortrait = (window.matchMedia("(orientation: portrait)").matches);
    // && orientationPortrait && screenRatio>=this.activeGameData.minRatioForPortraitPlay) {

    if (
      this.activeGameData.playOnPortrait &&
      window.matchMedia("(orientation: portrait)").matches &&
      this.activeGameData.isMobile &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay
    ) {
      this.displayModeLandscape = false;

      // this.bgContainer.height = 3000;
      // console.log(this.displayModeLandscape)
    } else {
      this.displayModeLandscape = true;
    }
    //    console.log(this.displayModeLandscape,(window.matchMedia("(orientation: portrait)").matches))
  };

  public setFullScreenDesktop = (): void => {
    //--desktop mode for both pc and mobile  used for stardice and fortune spin
    //rescaling option contents
    this.messageContainer.scale.set(1);
    this.messageContainer.x =
      this.activeGameData.size[0] / 2 - this.messageContainer.width / 2;
    this.messageContainer.y =
      this.activeGameData.size[1] / 2 - this.messageContainer.height / 2;

    this.setDesktopWidth(this.activeGameData.size[0]);
    this.setDesktopHeight(this.activeGameData.size[1] - 150);
    this.setOffsetY(-75);

    this.home.x = 0;
    this.setting.x = 0;
    this.replayBtn.x = 0;
    this.previous.x = 0;

    this.goal.x = 0;

    this.closeBtn.x = this.activeGameData.size[0] - 280;
    this.next.x = this.activeGameData.size[0] - 280;
    this.print.x = this.activeGameData.size[0] - 280;

    if (
      this.activeGameData.isDemo === false &&
      this.activeGameData.isTournament == false
    ) {
      this.replayBtn.y = this.activeGameData.size[1] - 330;
      this.goal.y = this.replayBtn.y - 100 * 2;
      this.setting.y = this.replayBtn.y - 100;
      this.print.y = this.replayBtn.y;
    } else {
      this.replayBtn.y = this.activeGameData.size[1] - 330;
      this.setting.y = this.activeGameData.size[1] - 330;
      this.goal.y = this.setting.y - 100;
      this.print.y = this.setting.y;
    }

    this.pagesContainerRoot.x = -125;
    this.pagesContainerRoot.y = -50;
    //   this.closeBtn.y=0
    //   this.home.y=0
  };
  private rescaleOptionToFitCenter = (): void => {
    if (this.activeGameData.isMobile == false && this.desktopSmallScreen) {
      //rescaling option contents
      this.messageContainer.scale.set(0.75);
      this.messageContainer.x =
        this.activeGameData.size[0] / 2 - this.messageContainer.width / 2;
      this.messageContainer.y =
        this.activeGameData.size[1] / 2 - this.messageContainer.height / 2;

      //change the position of btns

      let newX = 50;
      this.home.x += newX;

      this.goal.x += newX;
      this.setting.x += newX;
      this.replayBtn.x += newX;
      this.previous.x += 90;
      this.next.x -= 160;
      this.print.x -= 130;
      this.closeBtn.x -= 150;
      this.closeBtn.y -= 30;
      this.home.y -= 20;

      // console.log(this.home.y,this.activeGameData.isIphone)

      for (let i = 0; i < this.totalPages; i++) {
        this.pagesContainer[i].y -= 50;
        this.pagesContainer[i].x -= 40;
      }
    } else {
      //default elements are placed as mobile and dont need to be changed except for iphone .
      if (this.activeGameData.isIphone) {
        this.closeBtn.y += 60;
        this.home.y += 50;
        // console.log('newPOS')
      }
    }
  };

  public getFrame = (): PIXI.Sprite => {
    return this.optionBlackBG;
  };

  public getContainer = (): PIXI.Container => {
    return this.bgContainer;
  };

  public homeUrl = (): void => {
    onOptionButtonDownRedirectHome();
  };
  private createNavButtoms = (): void => {
    this.parentContainer.addChild(this.messageContainer);

    //Create The Titel BG
    let optionMSgBG: PIXI.Graphics = new PIXI.Graphics();
    optionMSgBG.beginFill(mainColor);
    optionMSgBG.drawRoundedRect(0, 0, 1600, 70, 0);
    optionMSgBG.endFill();
    optionMSgBG.x =
      this.activeGameData.size[0] / 2 - optionMSgBG.width / 2 + 10;
    optionMSgBG.y = 65;
    optionMSgBG.alpha = 0;
    this.messageContainer.addChild(optionMSgBG);

    let optionGameButtons: PIXI.Container = new PIXI.Container();
    this.messageContainer.addChild(optionGameButtons);

    this.home = new PIXI.Sprite(PIXI.Texture.fromImage("icon_Home.png"));
    this.home.anchor.set(0.5);
    this.home.buttonMode = false;
    this.home.interactive = false;
    this.home.scale.set(1.3);
    this.home.position.set(110, 80);
    this.home.hitArea = new PIXI.Rectangle(-50, -50, 100, 100);
    this.home.on("pointertap", this.homeUrl);
    this.home.on("mouseover", function() {
      this.alpha = 1;
    });
    this.home.on("mouseout", function() {
      this.alpha = 0.8;
    });
    // this.home.rotation=45*Math.PI/180;
    optionGameButtons.addChild(this.home);

    this.print = new PIXI.Sprite(PIXI.Texture.fromImage("icon_Print.png"));
    this.print.anchor.set(0.5);
    this.print.buttonMode = false;
    this.print.interactive = false;
    this.print.scale.set(1);
    this.print.hitArea = new PIXI.Rectangle(-50, -50, 100, 100);
    this.print.on("pointertap", this.onPrintClick);
    this.print.on("mouseover", function() {
      this.alpha = 1;
    });
    this.print.on("mouseout", function() {
      this.alpha = 0.8;
    });
    // this.home.rotation=45*Math.PI/180;
    optionGameButtons.addChild(this.print); //hidden for now
    this.print.position.set(this.activeGameData.size[0] - 130, 860);

    this.closeBtn = new PIXI.Sprite(PIXI.Texture.fromImage("icon_Close.png"));
    this.closeBtn.anchor.set(0.5);
    this.closeBtn.scale.set(1);
    this.closeBtn.buttonMode = false;
    this.closeBtn.interactive = false;

    this.closeBtn.position.set(this.activeGameData.size[0] - 100, 80);
    this.closeBtn.hitArea = new PIXI.Rectangle(-90, -75, 180, 150);
    this.closeBtn.on("pointertap", this.setClicked); // Defined on main faile

    this.home.on("mouseover", function() {
      this.alpha = 1;
    });
    this.home.on("mouseout", function() {
      this.alpha = 0.8;
    });
    optionGameButtons.addChild(this.closeBtn);
    this.home.scale.set(1);

    this.goal = new PIXI.Sprite(PIXI.Texture.fromImage("icon_Goal.png"));
    this.goal.anchor.set(0.5);
    this.goal.buttonMode = false;
    this.goal.interactive = false;
    this.goal.scale.set(1);
    // this.goal.position.set(110, 850 - 300);
    this.goal.hitArea = new PIXI.Rectangle(-50, -45, 100, 90);
    this.goal.on("pointertap", this.setActivePage.bind(this, "goal"), false);
    this.goal.on("mouseover", function() {
      this.alpha = 1;
    });
    this.goal.on("mouseout", function() {
      this.alpha = 0.8;
    });
    // this.goal.rotation=45*Math.PI/180;
    optionGameButtons.addChild(this.goal);
    this.goal.position.set(110, 860 - 300);

    this.jackpot = new PIXI.Sprite(PIXI.Texture.fromImage("icon_Trophy.png"));
    this.jackpot.anchor.set(0.5);
    this.jackpot.buttonMode = false;
    this.jackpot.interactive = false;
    this.jackpot.scale.set(1);
    this.jackpot.position.set(110, 860 - 250);
    this.jackpot.hitArea = new PIXI.Rectangle(-50, -45, 100, 90);
    this.jackpot.on(
      "pointertap",
      this.setActivePage.bind(this, "jackpot"),
      false
    );
    this.jackpot.on("mouseover", function() {
      this.alpha = 1;
    });
    this.jackpot.on("mouseout", function() {
      this.alpha = 0.8;
    });
    // this.jackpot.rotation=45*Math.PI/180;
    // optionGameButtons.addChild(this.jackpot); //hide jackpotPage

    this.setting = new PIXI.Sprite(PIXI.Texture.fromImage("icon_Setting.png"));
    this.setting.anchor.set(0.5);
    this.setting.buttonMode = false;
    this.setting.interactive = false;
    this.setting.scale.set(1);
    this.setting.position.set(110, 860 - 150);
    this.setting.hitArea = new PIXI.Rectangle(-50, -45, 100, 90);
    this.setting.on(
      "pointertap",
      this.setActivePage.bind(this, "setting"),
      false
    );
    this.setting.on("mouseover", function() {
      this.alpha = 1;
    });
    this.setting.on("mouseout", function() {
      this.alpha = 0.8;
    });
    // this.setting.rotation=45*Math.PI/180;
    optionGameButtons.addChild(this.setting);

    this.replayBtn = new PIXI.Sprite(
      PIXI.Texture.fromImage("replayBtn_open.png")
    );
    this.replayBtn.anchor.set(0.5);
    this.replayBtn.buttonMode = false;
    this.replayBtn.interactive = false;
    this.replayBtn.scale.set(1);
    this.replayBtn.position.set(110, 860);

    this.replayBtn.on("pointertap", this.activeGameData.replay.openReplay);
    this.replayBtn.on("mouseover", function() {
      this.alpha = 1;
    });
    this.replayBtn.on("mouseout", function() {
      this.alpha = 0.8;
    });

    if (this.activeGameData.isTournament == false) {
      let cashMode = getParameterByName("mode").toLowerCase() === "cash";
      let emulationMode =
        getParameterByName("mode").toLowerCase() === "emulation";
      if (cashMode || emulationMode) {
        optionGameButtons.addChild(this.replayBtn);
        // console.log("rpy---");
      }
    }

    // optionGameButtons.addChild(this.replayBtn);
    if (this.activeGameData.replay.isTestMode()) {
      starLog("replay");
      optionGameButtons.addChild(this.replayBtn);
    }

    this.next = new PIXI.Sprite(PIXI.Texture.fromImage("icon_Next.png"));
    this.next.anchor.set(0.5);
    this.next.buttonMode = false;
    this.next.interactive = false;
    // this.next.scale.set(2)
    this.next.position.set(this.activeGameData.size[0] - 90, 360);
    this.next.hitArea = new PIXI.Rectangle(-90, -75, 180, 150);
    this.next.on("pointertap", this.setActivePage.bind(this, "next"), false);
    this.next.on("mouseover", function() {
      this.alpha = 1;
    });
    this.next.on("mouseout", function() {
      this.alpha = 0.8;
    });
    this.messageContainer.addChild(this.next);

    this.previous = new PIXI.Sprite(PIXI.Texture.fromImage("icon_Next.png"));

    this.previous.anchor.set(0.5);
    this.previous.scale.set(-1);
    this.previous.buttonMode = false;
    this.previous.interactive = false;
    this.previous.position.set(70, 360);
    this.previous.hitArea = new PIXI.Rectangle(-90, -75, 180, 150);
    this.previous.on(
      "pointertap",
      this.setActivePage.bind(this, "previous"),
      false
    );
    this.previous.on("mouseover", function() {
      this.alpha = 1;
    });
    this.previous.on("mouseout", function() {
      this.alpha = 0.8;
    });
    this.messageContainer.addChild(this.previous);
    if (this.activeGameData.isMobile) {
      this.closeBtn.scale.set(2);
      this.print.scale.set(2);
    }

    for (var i = 0; i < 3; i++) {
      this.iconHighlight[i] = new PIXI.Graphics();

      //curretPageHighlight.beginFill(0xff0000);
      this.iconHighlight[i].lineStyle(2, subColor, 1);
      this.iconHighlight[i].drawCircle(0, 0, 33); //drawRoundedRect(-33, -33,66 ,66,1);
      this.iconHighlight[i].alpha = 0;
      // this.iconHighlight[i].rotation=45*Math.PI/180
      if (i === 0) {
        this.goal.addChild(this.iconHighlight[i]);
      }

      if (i === 1) {
        this.jackpot.addChild(this.iconHighlight[i]);
      }

      if (i === 2) {
        this.setting.addChild(this.iconHighlight[i]);
      }
    }

    this.home.alpha = 0.8;
    this.closeBtn.alpha = 0.8;
    this.goal.alpha = 1;
    this.jackpot.alpha = 0.8;
    this.setting.alpha = 0.8;
    // this.iconHighlight[0].alpha = 1;

    this.setUpPages();
  };

  private setUpPages = (): void => {
    this.pagesContainer = [];
    for (var i = 0; i < this.totalPages; i++) {
      this.pagesContainer[i] = new PIXI.Container();
      this.pagesContainerRoot.addChild(this.pagesContainer[i]);
    }
    for (var i = 0; i < this.totalPages; i++) {
      this.pagesContainer[i].alpha = 0;
    }

    //create option page that remains same for all games on last page
    this.jackpotPageSetup();
    this.optionPageSetup();
    this.pages[this.totalPages - 1] = new Page(
      this.totalPages - 1,
      this.activeGameData.gameTextGeneral.optp7head,
      this.settingBtnsContainer,
      this.pagesContainer[this.totalPages - 1],
      this.desktopSmallScreen
    );
    // this.pagesContainer[this.totalPages - 1].alpha = 1;
    this.parentContainer.alpha = 0;
  };

  public setPageNewY = (newY: number): void => {
    this.pagesContainerRoot.y = newY;
    // console.log('APPLY NEW Y')
  };

  private jackpotPageSetup = (): void => {
    this.setPages(
      this.totalPages - 2,
      this.activeGameData.gameTextGeneral.jackpot,
      this.activeGameData.gameTextGeneral.jackpotPageText
    );
  };
  private optionPageSetup = (): void => {
    //ADD SWITCHS

    this.settingBtnsContainer = new PIXI.Container(); //add inside the page-1

    let recenter: PIXI.Graphics = new PIXI.Graphics();
    recenter.beginFill(mainColor);
    recenter.drawRect(
      0,
      0,
      this.activeGameData.size[0],
      this.activeGameData.size[1]
    );
    recenter.endFill();
    // this.settingsContainer.addChild(recenter);
    this.fullscreentoggleSwitch = new ToggleSwitch(
      this.activeGameData.gameTextGeneral.optp7msg
    );
    this.bgMusicToggleSwitch = new ToggleSwitch(
      this.activeGameData.gameTextGeneral.bgMusic
    );
    this.bonusMusicToggleSwitch = new ToggleSwitch(
      this.activeGameData.gameTextGeneral.bonusMusic
    );
    this.animationtoggleSwitch = new ToggleSwitch(
      this.activeGameData.gameTextGeneral.optp7msg3
    );
    this.soundsliderButton = new ToggleSwitch(
      this.activeGameData.gameTextGeneral.optp7msg5
    );

    this.TurboSlierButton = new ToggleSwitch("Turbo Mode");

    let posX = -+0;
    let posY = 50;
    if (
      this.activeGameData.isMobile == false ||
      this.desktopSmallScreen == false
    ) {
      this.fullscreentoggleSwitch.placeButton(this.settingBtnsContainer, [
        posX,
        posY,
      ]);
    } else {
      posY = -75;
      // posY = 0;
    }

    this.bgMusicToggleSwitch.placeButton(this.settingBtnsContainer, [
      posX,
      posY + 100,
    ]);
    this.bonusMusicToggleSwitch.placeButton(this.settingBtnsContainer, [
      posX,
      posY + 200,
    ]);
    this.soundsliderButton.placeButton(this.settingBtnsContainer, [
      posX,
      posY + 300,
    ]);

    this.fullHDSliderButton = new ToggleSwitch(
      this.activeGameData.gameTextGeneral.fullHD
    );
    this.fullFpsSlierButton = new ToggleSwitch(
      this.activeGameData.gameTextGeneral.fullFps
    );

    if (this.activeGameData.isMobile == false) {
      this.fullHDSliderButton.placeButton(this.settingBtnsContainer, [
        posX,
        posY + 400,
      ]);
      this.fullFpsSlierButton.placeButton(this.settingBtnsContainer, [
        posX,
        posY + 500,
      ]);
    } else {
      this.fullFpsSlierButton.placeButton(this.settingBtnsContainer, [
        posX,
        posY + 400,
      ]);
    }

    if (this.activeGameData.turboModeAllowed) {
      // this.TurboSlierButton
      let posYOffset = 600;
      if (this.activeGameData.isMobile) {
        posYOffset = 500;
      }
      this.TurboSlierButton.placeButton(this.settingBtnsContainer, [
        posX,
        posY + posYOffset,
      ]);
      this.setTurboOn(this.activeGameData.turboEnabled);
    }
  };
  private displayPageOne = (): void => {
    this.autoUpdateSettingsPage(); //update the settings
    //  this.updatePage6()//Update the winner pages
    this.currentPage = 0;
    this.activeGameData.gameBar.setMobileUIHidden(true);
    this.isClosed = !this.isClosed;
    this.parentContainer.alpha = 1;

    for (var i = 0; i < this.totalPages; i++) {
      this.pagesContainer[i].alpha = 0;
    }
    this.pagesContainer[0].alpha = 1;
    this.setInteractivity(true);
  };
  private autoUpdateSettingsPage = (): void => {
    if (isFullScreen() && this.fullscreentoggleSwitch.getIsOn() === false) {
      this.fullscreentoggleSwitch.setOn(true);
    }
    if (
      this.activeGameData.normalGameMusicList[0].mute() == false &&
      this.bgMusicToggleSwitch.getIsOn() === false
    ) {
      this.bgMusicToggleSwitch.setOn(true);
    }
    if (
      this.activeGameData.bonusMusicList[0].mute() == false &&
      this.bonusMusicToggleSwitch.getIsOn() === false
    ) {
      this.bonusMusicToggleSwitch.setOn(true);
    }
    if (
      this.activeGameData.soundList[0].mute() == false &&
      this.soundsliderButton.getIsOn() === false
    ) {
      this.soundsliderButton.setOn(true);
    }
    if (!isFullScreen() && this.fullscreentoggleSwitch.getIsOn() === true) {
      this.fullscreentoggleSwitch.setOn(false);
    }
    if (
      this.activeGameData.normalGameMusicList[0].mute() == true &&
      this.bgMusicToggleSwitch.getIsOn() === true
    ) {
      this.bgMusicToggleSwitch.setOn(false);
    }
    if (
      this.activeGameData.bonusMusicList[0].mute() == true &&
      this.bonusMusicToggleSwitch.getIsOn() === true
    ) {
      this.bonusMusicToggleSwitch.setOn(false);
    }
    if (
      this.activeGameData.soundList[0].mute() == true &&
      this.soundsliderButton.getIsOn() === true
    ) {
      this.soundsliderButton.setOn(false);
    }
    // console.log("autoooo")
  };

  private setFunction = (fn: Function, Btn: ToggleSwitch): void => {
    // Btn.switchColorA.on('pointertap',fn.bind(undefined,this.activeGameData));
    Btn.setFunction(fn.bind(undefined, this.activeGameData));
  };

  private setFunctionFullScreen = (fn: Function): void => {
    this.setFunction(fn, this.fullscreentoggleSwitch);
  };
  private setFunctionFPS = (fn: Function): void => {
    this.setFunction(fn, this.fullFpsSlierButton);
  };
  private setFunctionHD = (fn: Function): void => {
    this.setFunction(fn, this.fullHDSliderButton);
  };

  private autoSetupFunctions() {
    this.setFunctionFPS(toggle60Fps);
    this.setFunctionHD(toggleFullHD);
    this.setFunctionFullScreen(toggleFullScreenOption);
    this.setFunctionBgMusic(toggleMuteOption);
    this.setFunctionBonusMusic(toggleBonusMusicOption);
    this.setFunctionSounds(changeSoundVolume);
    this.setFunctionTurbo(toggleTurboMode);
  }

  //Public Functions
  public setInteractivity = (changeBool: boolean): void => {
    // console.log("setInteractivity", changeBool)
    this.home.buttonMode = changeBool;
    this.home.interactive = changeBool;
    this.print.buttonMode = changeBool;
    this.print.interactive = changeBool;
    this.closeBtn.buttonMode = changeBool;
    this.closeBtn.interactive = changeBool;
    this.goal.buttonMode = changeBool;
    this.goal.interactive = changeBool;
    this.jackpot.buttonMode = changeBool;
    this.jackpot.interactive = changeBool;
    this.setting.buttonMode = changeBool;
    this.setting.interactive = changeBool;
    this.next.buttonMode = changeBool;
    this.next.interactive = changeBool;
    this.previous.buttonMode = changeBool;
    this.previous.interactive = changeBool;

    this.replayBtn.buttonMode = changeBool;
    this.replayBtn.interactive = changeBool;
  };
  public setActivePage = (param: string): void => {
    if (param === "next") {
      this.currentPage += 1;
    }

    if (param === "previous") {
      this.currentPage -= 1;
    }

    // If jackpot is not available, skip the jackpot page
    if (!this.activeGameData.jackPotGameInstantiated) {
      const jackpotPageIndex = this.totalPages - 2; //second last page is jackpot page

      if (this.currentPage === jackpotPageIndex) {
        // Skip the jackpot page
        if (param === "next") {
          this.currentPage += 1;
        } else if (param === "previous") {
          this.currentPage -= 1;
        }
      }
    }

    if (this.currentPage > this.totalPages - 1) {
      this.currentPage = 0;
    }
    if (this.currentPage < 0) {
      this.currentPage = this.totalPages - 1;
    }

    if (param === "goal") {
      this.currentPage = 0;
    }
    // if (param==="jackpot"){this.currentPage=4}
    if (param === "setting") {
      this.currentPage = this.totalPages - 1;
    }

    // console.log(this.currentPage)
    for (var i = 0; i < this.pages.length; i++) {
      this.pagesContainer[i].alpha = 0;
    }
    this.pagesContainer[this.currentPage].alpha = 1;

    if (this.currentPage === this.totalPages - 1) {
      this.fullscreentoggleSwitch.setInteractive(true); //switchColorA.interactive = true;
      this.bgMusicToggleSwitch.setInteractive(true);
      this.bonusMusicToggleSwitch.setInteractive(true);
      this.soundsliderButton.setInteractive(true);
      this.animationtoggleSwitch.setInteractive(true);
      // console.log("enable")
      this.fullHDSliderButton.setInteractive(true);
      this.fullFpsSlierButton.setInteractive(true);

      this.TurboSlierButton.setInteractive(true);
    } else {
      this.fullscreentoggleSwitch.setInteractive(false);
      this.bgMusicToggleSwitch.setInteractive(false);
      this.bonusMusicToggleSwitch.setInteractive(false);
      this.soundsliderButton.setInteractive(false);
      this.animationtoggleSwitch.setInteractive(false);
      this.fullHDSliderButton.setInteractive(false);
      this.fullFpsSlierButton.setInteractive(false);
      this.TurboSlierButton.setInteractive(false);

      // console.log("disable")
    }

    this.iconHighlight[0].alpha = 0;
    this.iconHighlight[1].alpha = 0;
    this.iconHighlight[2].alpha = 0;
    if (this.currentPage < 6) {
      this.iconHighlight[0].alpha = 0;
    }
    // else if (this.currentPage===4 ||this.currentPage===5 ){this.iconHighlight[1].alpha=1;}
    else if (this.currentPage > 5) {
      this.iconHighlight[2].alpha = 0;
    }
  };
  public setPages(num: number, head: string, body: any) {
    // console.log(num)
    this.pages[num] = new Page(
      num,
      head,
      body,
      this.pagesContainer[num],
      this.desktopSmallScreen
    );
  }

  public getPages = (): Array<Page> => {
    return this.pages;
  };
  public removeFromCanvas() {
    this.optionBlackBG.interactive = false;
    this.isClosed = !this.isClosed;
    this.parentContainer.alpha = 0;
    this.setActivePage("goal"); //makes  default page to 0 and also disable buttons
    for (var i = 0; i < this.totalPages; i++) {
      this.pagesContainer[i].alpha = 0;
      this.setInteractivity(false);
    }

    this.activeGameData.gameBar.setMobileUIHidden(false);
  }
  public setClicked = (): void => {
    if (this.isClosed) {
      this.displayPageOne();

      this.open();
      this.optionBlackBG.interactive = true;
    } else {
      this.activeGameData.gameBar.setMobileUIHidden(false);
      this.close();
      this.optionBlackBG.interactive = false;
    }
  };

  private onPrintClick = (): void => {
    let gameHasBuyBonus = this.activeGameData.loginResponse.gameSettings
      .buyBonusEnabled;
    let gameHasAutoPlay = this.activeGameData.commonConfigData.autoplayEnabled;
    let gameHasJackpot = this.activeGameData.jackPotGameInstantiated;
    starLog(" jackpot Avaible", this.activeGameData.jackPotGameInstantiated);
    onOptionButtonDownRedirectPrint(
      gameHasBuyBonus,
      gameHasAutoPlay,
      gameHasJackpot
    );
  };

  public addImageToPage(
    pageNumber: number,
    sprite: PIXI.Sprite,
    pos: Array<number>,
    defaultScale: number = 1,
    portraitScale: number = 1,
    anchorY: number = 0
  ) {
    this.pages[pageNumber].setImage(
      sprite,
      pos,
      defaultScale,
      portraitScale,
      anchorY
    );
    // console.log(portraitScale)
  }

  private setFunctionBgMusic = (fn: Function): void => {
    this.setFunction(fn, this.bgMusicToggleSwitch);
  };
  private setFunctionBonusMusic = (fn: Function): void => {
    this.setFunction(fn, this.bonusMusicToggleSwitch);
  };
  private setFunctionSounds = (fn: Function): void => {
    this.setFunction(fn, this.soundsliderButton);
  };
  private setFunctionTurbo = (fn: Function): void => {
    this.setFunction(fn, this.TurboSlierButton);
  };

  public getFullScreenIsOn = (): boolean => {
    return this.fullscreentoggleSwitch.getIsOn();
  };
  public getBgMusicIsOn = (): boolean => {
    return this.bgMusicToggleSwitch.getIsOn();
  };
  public getBonusMusicIsOn = (): boolean => {
    return this.bonusMusicToggleSwitch.getIsOn();
  };
  public getSoundIsOn = (): boolean => {
    return this.soundsliderButton.getIsOn();
  };
  public getFPSIsOn = (): boolean => {
    return this.fullFpsSlierButton.getIsOn();
  };
  public getHDIsOn = (): boolean => {
    return this.fullHDSliderButton.getIsOn();
  };

  public setTurboOn = (bool: boolean): void => {
    this.TurboSlierButton.setOn(bool);
  };
  public setFullScreenOn = (bool: boolean): void => {
    this.fullscreentoggleSwitch.setOn(bool);
  };
  public setBgMusicOn = (bool: boolean): void => {
    this.bgMusicToggleSwitch.setOn(bool);
  };
  public setBonusMusicOn = (bool: boolean): void => {
    this.bonusMusicToggleSwitch.setOn(bool);
  };
  public setSoundOn = (bool: boolean): void => {
    this.soundsliderButton.setOn(bool);
  };

  public setFpsOn = (bool: boolean): void => {
    this.fullFpsSlierButton.setOn(bool);
  };
  public setHDOn = (bool: boolean): void => {
    this.fullHDSliderButton.setOn(bool);
  };

  public getTotalPages = (): number => {
    return this.totalPages;
  };

  public getIsClosed = (): boolean => {
    return this.isClosed;
  };
  public setPageAlpha = (pageNum: number, alphaV: number): void => {
    this.pagesContainer[pageNum].alpha = alphaV;
  };

  public getContainerWidth = (): number => {
    return this.bgContainer.width;
  };
  public getContainerHeight = (): number => {
    return this.bgContainer.height;
  };
  public setIsClosed = (bool: boolean): void => {
    this.isClosed = bool;
  };
  public setOptionAlpha(alphaValue: number) {
    this.parentContainer.alpha = alphaValue;
  }

  private setContainerHeight = (newValue: number): void => {
    // this.optionBlackBG.width=this.bgContainer.width;
    // this.optionBlackBG.height=newValue;
    this.bgContainer.height = newValue;
  };
  private setContainerWidth = (newValue: number): void => {
    this.bgContainer.width = newValue;
    // this.optionBlackBG.
  };
  private setContainerPosition = (pos: Array<number>): void => {
    this.bgContainer.position.set(pos[0], pos[1]);
  };
  // public set

  public setDesktopWidth(val: number) {
    this.bgWidth = val;
  }
  public setDesktopHeight(val: number) {
    this.bgHeight = val;
  }
  public setOffsetY = (newOff: number): void => {
    //only for desktop version
    this.offsetY = newOff;
  };
  public getTitleLine = (): PIXI.Sprite => {
    return this.sidebar;
  };

  public onResize = (): void => {
    // this.setContainerHeight(this.activeGameData.size[1] - this.activeGameData.gameBar.getGameBarHeight());

    // if(orientationPortrait && screenRatio>=this.activeGameData.minRatioForPortraitPlay)
    if (this.activeGameData.isMobile || this.desktopSmallScreen == false) {
      this.setDisplayMode();
      if (this.displayModeLandscape) {
        this.optionBlackBG.alpha = 1;
        this.portraitBG.alpha = 0;
        // this.portraitBG.height=0
        // this.setContainerWidth(this.activeGameData.size[0]);
        this.setContainerHeight(this.activeGameData.size[1] - 23);
        this.UIPortraitMode(false);
      } else {
        let canvas = document.getElementsByTagName("canvas")[0];
        // this.portraitBG.height = canvas.height//(this.activeGameData.gameResolution[1]/this.activeGameData.size[1]);
        this.optionBlackBG.alpha = 1;
        this.portraitBG.alpha = 1;
        let multiplierScale =
          this.activeGameData.gameResolution[1] / this.activeGameData.size[1];
        //    console.log(multiplierScale)
        // let newHeight=(canvas.height-this.activeGameData.portraitPlayOffsetTop)/multiplierScale-400*multiplierScale;//old
        let newHeight =
          (canvas.height - this.activeGameData.portraitPlayOffsetTop) /
            multiplierScale -
          300 * multiplierScale;
        if (this.activeGameData.gameResolution[1] < 720) {
          newHeight =
            (canvas.height - this.activeGameData.portraitPlayOffsetTop) /
              multiplierScale +
            715 * multiplierScale -
            205; //205 substracted to fix the pportrait overlaping
        }

        this.portraitBG.width = newHeight; //bc of rotation

        // console.log()
        this.portraitBG.height = this.activeGameData.size[0]; //bc of rotation
        this.setContainerHeight(newHeight);
        this.UIPortraitMode(true);
        // this.setDesktopHeight(canvas.height)
      }
    } else {
      this.setContainerWidth(this.bgWidth);
      this.setContainerHeight(this.bgHeight);
      let posX = this.activeGameData.size[0] / 2 - this.getContainerWidth() / 2; //
      let posY =
        this.activeGameData.size[1] / 2 -
        this.getContainerHeight() / 2 +
        12.5 +
        this.offsetY; //;
      this.setContainerPosition([posX, posY]);
    }

    if (this.desktopSmallScreen == false) {
      this.parentContainer.y = 0;
    }

    // console.log(this.bgWidth)
    // console.log(this.activeGameData.gameScene.height)
  };

  private UIPortraitMode = (bool: boolean): void => {
    let scale = 2;
    if (
      this.desktopSmallScreen == false &&
      this.activeGameData.isMobile == false
    ) {
      scale = 1;
    }
    scale;
    bool;

    if (bool) {
      // portrait mode scale and palce
      scale = 2;

      this.next.scale.set(scale);
      this.previous.scale.set(-scale);
      this.home.scale.set(scale);
      this.closeBtn.scale.set(scale);
      this.replayBtn.scale.set(scale);
      this.print.scale.set(scale);
      this.goal.scale.set(scale);
      this.setting.scale.set(scale);

      let offsetX = 50;
      this.next.x = 1830 - offsetX;
      this.previous.x = 110 + offsetX;
      this.home.x = 110 + offsetX;
      this.closeBtn.x = 1830 - offsetX;
      this.replayBtn.x = 110 + offsetX;
      this.print.x = 1790 - offsetX;
      this.goal.x = 110 + offsetX;
      this.setting.x = 110 + offsetX;

      this.home.y = 200;
      this.closeBtn.y = 200;

      // this.portraitBG.height
      let hBtn = 300;
      this.next.y = this.portraitBG.width - hBtn * 6;
      this.previous.y = this.portraitBG.width - hBtn * 6;

      this.goal.y = this.portraitBG.width - hBtn * 3;
      this.setting.y = this.portraitBG.width - hBtn * 2;
      this.replayBtn.y = this.portraitBG.width - hBtn * 1;
      this.print.y = this.portraitBG.width - hBtn * 1;

      this.next.y = this.portraitBG.width / 2 - hBtn; //1830-offsetX;
      this.previous.y = this.portraitBG.width / 2 - hBtn; //90+offsetX;

      for (let i = 0; i < this.pagesContainer.length; i++) {
        this.pagesContainer[i].y = 100;
      }

      this.pages[this.pages.length - 1].setBodyElemScale(2); //scale the setting page body
    } else {
      //set to default  horizontal layout mobile
      scale = scale / 2;
      this.next.scale.set(scale);
      this.previous.scale.set(-scale);
      this.home.scale.set(scale);
      this.closeBtn.scale.set(scale);
      this.replayBtn.scale.set(scale);
      this.print.scale.set(scale);
      this.goal.scale.set(scale);
      this.setting.scale.set(scale);

      this.next.x = 1830;
      this.previous.x = 110;
      this.home.x = 110;
      this.closeBtn.x = 1830;
      this.replayBtn.x = 110;
      this.print.x = 1830;
      this.print.y = this.replayBtn.y;
      this.goal.x = 110;
      this.setting.x = 110;

      this.next.y = 360;
      this.previous.y = 360;
      this.home.y = 80;
      this.closeBtn.y = 80;
      this.replayBtn.y = 860;
      this.print.y = 860;
      this.goal.y = 560;
      this.setting.y = 710;

      //
      if (scale == 1) {
        this.replayBtn.y = this.bgContainer.height - this.replayBtn.height * 2;
        this.setting.y = this.replayBtn.y - this.goal.height * 1.5;
        this.goal.y = this.setting.y - this.goal.height * 1.5;
        this.print.y = this.replayBtn.y;
        this.next.scale.set(scale);
        this.previous.scale.set(-scale);
      }

      if (this.activeGameData.isIphone) {
        this.closeBtn.y += 60;
        this.home.y += 50;
      }

      for (let i = 0; i < this.pagesContainer.length; i++) {
        this.pagesContainer[i].y = 0;
      }

      this.pages[this.pages.length - 1].setBodyElemScale(1); //reset scale the setting page body
    }
  };
  public setHomeAndClosePosY = (value: number): void => {
    this.home.y = value;
    this.closeBtn.y = value - 10;
  };

  public getParent = (): PIXI.Container => {
    return this.parentContainer;
  };
}
